import angular from 'angular';
/**
 * @ngdoc decorator
 * @name xhrFactoryDecorator
 * @description
 * Overwrite the XHR creation in order to hook an event listener for the progress event.
 * In order to get the progress percentage, you can include an `onProgress` callback on your `$http`
 * call configuration.
 * I _kind of_ copied this from [here](http://bit.ly/2m6Eo7M).
 *
 * @param  {Service} $delegate The original service of the decorator.
 * @param  {Service} $injector Necessary in order to get the `$http` service instance.
 * @return {Function}
 */
const xhrFactoryDecorator = ($delegate, $injector) => {
  'ngInject';

  return (method, url) => {
    const xhr = $delegate(method, url);
    const $http = $injector.get('$http');
    const callConfig = $http.pendingRequests[$http.pendingRequests.length - 1];
    if (angular.isFunction(callConfig.onProgress)) {
      xhr.addEventListener('progress', (event) => {
        const completedPercentage = 100;
        callConfig.onProgress((event.loaded / event.total) * completedPercentage);
      });
    }

    return xhr;
  };
};

export default xhrFactoryDecorator;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/decorators/xhrFactory.decorator.js